import type { ColumnDef } from '@tanstack/react-table';
import { DateCell } from '@/components/data-table/cells';
import { StatusChip } from '@/components/ui/status-chip';
import type { FxRecord } from '@/services/api/fx-swaps';
import { FX_STATUS_CHIP_VARIANTS, formatFxAmount, formatFxNumber, formatFxPrice } from './fx-swap-format';

const CHIP_CLASS = 'px-2 py-0.5 text-xs';

// Column order, headers and formats — all columns are non-sortable
// (legacy parity). Raw numbers stay in the row data; formatting happens here.
export const FX_SWAP_TABLE_COLUMNS: ColumnDef<FxRecord, unknown>[] = [
  {
    accessorKey: 'status',
    header: 'Status',
    enableSorting: false,
    cell: ({ row }) => (
      <StatusChip className={CHIP_CLASS} variant={FX_STATUS_CHIP_VARIANTS[row.original.status]}>
        {row.original.status.toUpperCase()}
      </StatusChip>
    ),
  },
  {
    accessorKey: 'created_at',
    header: 'Created At',
    enableSorting: false,
    cell: ({ row }) => <DateCell value={row.original.created_at} />,
  },
  { accessorKey: 'from_currency', header: 'From', enableSorting: false },
  { accessorKey: 'to_currency', header: 'To', enableSorting: false },
  {
    accessorKey: 'amount',
    header: 'Amount',
    enableSorting: false,
    cell: ({ row }) => <span className="whitespace-nowrap tabular-nums">{formatFxAmount(row.original.amount)}</span>,
  },
  {
    accessorKey: 'customer_price',
    header: 'Customer Price',
    enableSorting: false,
    cell: ({ row }) => <span className="whitespace-nowrap tabular-nums">{formatFxPrice(row.original.customer_price)}</span>,
  },
  {
    accessorKey: 'trade_price',
    header: 'Trade Price',
    enableSorting: false,
    cell: ({ row }) => <span className="whitespace-nowrap tabular-nums">{formatFxPrice(row.original.trade_price)}</span>,
  },
  {
    accessorKey: 'pnl',
    header: 'P&L',
    enableSorting: false,
    cell: ({ row }) => {
      const pnl = row.original.pnl;
      if (pnl === null || pnl === undefined) return 'N/A';
      return (
        <StatusChip className={`${CHIP_CLASS} tabular-nums`} variant={pnl >= 0 ? 'success' : 'destructive'}>
          {formatFxNumber(pnl)}
        </StatusChip>
      );
    },
  },
];
